import React from 'react';
import Contact from './Contact';
import Hero from './Hero';
import MySkills from './MySkills';
import Projects from './Projects';

const Home = () => {
    return (
        <div>
            <Hero></Hero>
            <Projects></Projects>
            <MySkills></MySkills>
            <Contact></Contact>
        </div>
    );
};

export default Home;